import styled from "styled-components";

export const Text = styled.div`
  margin-bottom: 30px;
`;
